import { useEffect, useState } from "react";
import { useAuth } from "../../../../../modules/auth";
import { useLazyReadMultipleQuery } from "../../../../services/data/tableDataApi";
import { FieldFilterType } from "../../../../base/types";
import { ICourseAndSection } from "./assessment";

export const useGetCourseAndSection = () => {
  const { user, siteId } = useAuth();
  const [getCourseAndSection] = useLazyReadMultipleQuery();
  const [records, setRecords] = useState<ICourseAndSection[]>([]);

  useEffect(() => {
    getRecords();

    // eslint-disable-next-line
  }, [user]);

  const getRecords = (): Promise<ICourseAndSection[]> => {
    if (!user?.contactId) {
      return Promise.reject('User contact not found.');
    }

    return getCourseAndSection({
      userId: user?.userId || '',
      portalId: siteId || '',
      tableId: "mshied_coursehistory",
      fieldList: ["mshied_studentid", "mshied_courseid", "edtec365_sectionmain"],
      filters: [{
        group: 0, filters: [
          { field: "mshied_studentid", type: FieldFilterType.Const, value: user?.contactId || '' },
          { field: "mshied_registrationstatusid", type: FieldFilterType.Const, value: "9878b24c-9b2c-ef11-8e4f-002248d632e5" }, //guid is for completed registrations
        ]
      }]
    })
      .unwrap()
      .then((data) => {
        const routeRecords = data.records.map<ICourseAndSection>(p => ({
          courseid: p["mshied_courseid"],
          sectionmain: p["edtec365_sectionmain"]
        }));

        setRecords(routeRecords);
        return Promise.resolve(routeRecords);
      });
  }

  return { data: records };
}